import {observable, makeObservable} from "mobx";
import {IVideoSlidesFilter as IVideoSlidesFilterConfig} from "../../../configurations/config-data-sections/arenas.configuration";
import {IServiceFactory} from "../../../service-factory.interface";
import {IVideoSlidesFilterViewModel} from "./video-slides-filter-view-model.interface";

export class VideoSlidesFilterModel implements IVideoSlidesFilterViewModel {
    constructor(protected readonly services: IServiceFactory, protected readonly videoSlidesFilterConfig: IVideoSlidesFilterConfig) {
        makeObservable(this);
        this.icon = this.videoSlidesFilterConfig.icon;
    }

    get id(): string {
        return this.videoSlidesFilterConfig.id;
    }

    get title(): string {
        return this.videoSlidesFilterConfig.translationKey
    }
    icon?: string;

    @observable.ref
    protected _on: boolean = false;
    get on(): boolean {
        return this.services.gamesFilter.isFilterApplied(this.videoSlidesFilterConfig.id);
    }

    get shouldBeDisplayed(): boolean {
        let isValidFilterForCurrentArena = this.services.gamesFilter.isValidFilter(this.videoSlidesFilterConfig.id);
        //let hasGamesForCurrentFilter = this.services.gamesFilter.getNumberOfGamesBeforeUserApply([this.videoSlidesFilterConfig.id]) > 0
        return isValidFilterForCurrentArena;
    }

    async applyFilter(): Promise<void> {
        await this.services.gamesFilter.applyFilters([this.videoSlidesFilterConfig.id]);
    }

}